import * as React from 'react';
import { SVGProps } from 'react';

export const MissedStatus = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M16.222 17H3.778C2.8 17 2 16.1 2 15V9c0-1.1.8-2 1.778-2h12.444C17.2 7 18 7.9 18 9v6c0 1.1-.8 2-1.778 2Z"
            fill="#FFCED1"
            stroke="#FF333F"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6 7V5a4 4 0 0 1 4-4v0a4 4 0 0 1 4 4v2M10 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
            stroke="#FF333F"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const LateStatus = (props: SVGProps<SVGSVGElement>) => (
    <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            opacity="0.4"
            d="M9.50019 8.5999C10.8345 7.68115 12.9002 6.4999 12.9002 5.0999V4.3999H2V4.9999C2 6.3999 4.1 8.4999 5.4 8.4999H6.23921V11.3843C4.03921 12.1843 2.40019 14.9999 2.40019 17.3999H12.4002C12.4002 14.9999 10.9548 12.1843 8.75483 11.3843V8.5999H9.50019Z"
            fill="#FF5722"
        />
        <path
            d="M13.5 3V1H1.5V3C1.5 5.8 3.1 7.2 5.5 8.3V9.7C4.1 10.8 1.5 12.2 1.5 15V17H13.5V15C13.5 12.2 11.9 10.8 9.5 9.7V8.3C11.8 7.1 13.5 5.7 13.5 3Z"
            stroke="#FF5722"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ExtraCreditStatus = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="m11.028 1.664 1.87 3.996a1.13 1.13 0 0 0 .86.649l4.27.649a1.15 1.15 0 0 1 .942 1.383 1.149 1.149 0 0 1-.292.545l-3.17 3.256a1.137 1.137 0 0 0-.31.998l.74 4.535a1.127 1.127 0 0 1-1.056 1.324c-.214.01-.427-.04-.614-.146l-3.72-2.057a1.13 1.13 0 0 0-1.1 0l-3.72 2.057a1.131 1.131 0 0 1-1.67-1.178l.74-4.535a1.138 1.138 0 0 0-.31-.998l-3.17-3.256a1.148 1.148 0 0 1 .65-1.928l4.27-.65a1.13 1.13 0 0 0 .86-.648l1.87-3.996a1.13 1.13 0 0 1 2.06 0Z"
            fill="#FEF5E1"
            stroke="#FFAB00"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.528 9.495s2.34 3.376 5 0"
            stroke="#FFAB00"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ReassignStatus = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M16 18.5H4.5c-1.1 0-2-.9-2-2v-13c0-1.1.9-2 2-2H12l.5 6H18v9c0 1.1-.9 2-2 2Z"
            fill="#BAE8ED"
        />
        <path
            d="M12 1.5v4c0 1.1.9 2 2 2h4"
            stroke="#01AAB9"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18 7.5v9.05c0 1.1-.9 2-2 2L4.5 18.5c-1.1 0-2-.9-2-2v-13c0-1.1.9-2 2-2H12l6 6Z"
            stroke="#01AAB9"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 18.5v-7h6"
            stroke="#01AAB9"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="m11 9.5 2 2-2 2"
            stroke="#01AAB9"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const IncompleteStatus = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path opacity={0.4} d="M9.8 18.8a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" fill="#B7A8EC" />
        <path
            d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM6 10h8"
            stroke="#6848D4"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const ExcusedStatus = (props: SVGProps<SVGSVGElement>) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path opacity={0.4} d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" fill="#9CA3AF" />
        <path
            d="M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM4 16 16 4"
            stroke="#9CA3AF"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const SkippedStatus = (props) => (
    <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="m18.55 11.05-7.5 7.5c-.6.6-1.5.6-2.1 0l-7.5-7.5c-.6-.6-.6-1.5 0-2.1l7.5-7.5c.6-.6 1.5-.6 2.1 0l7.5 7.5c.6.6.6 1.5 0 2.1Z"
            stroke="#2278ED"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            opacity={0.4}
            d="m18.55 11.05-7.5 7.5c-.6.6-1.5.6-2.1 0l-7.5-7.5c-.6-.6-.6-1.5 0-2.1l7.5-7.5c.6-.6 1.5-.6 2.1 0l7.5 7.5c.6.6.6 1.5 0 2.1Z"
            fill="#2278ED"
        />
        <path
            d="m12.05 8.05 2 2-2 2M7.05 8.05l2 2-2 2"
            stroke="#2278ED"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
